module.exports = __webpack_public_path__ + "img/17c3752.png";